<template>
  <div style="height: 100%">
    <!-- <Header /> -->
    <router-view />
  </div>
</template>

<script>
// import Header from "./Header/index.vue";
export default {
  components: {
    // Header,
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>
